module.exports = __webpack_public_path__ + "img/curve_1.038998a9.png";